export const environment = {
    production: false,
    urlBack: 'https://nextchance.api.atalaya.ai/api/v1/',
    urlFront: 'https://nextchance.app.atalaya.ai/login',
    client_id: 'kbVZSoYGxAAiXIU3sBlq2TQAcU4n5Wd0JT6Se7EL',
    client_secret:
        'MogdkhxHjrhXrzIpL6V19eArwP2YvLIXaHcT31mYBM5sdXYZm5Cr4rmSTIKoHPPXfynDnB3HKw1BMAYWCu2TXis8ikvfeAaswEs0WXPowC0dnPNgUXTaTfevUBbUTEeI',
};
